import { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from 'react-icons/fa';
import { AC_YEAR_OLD } from '../../CommonUtils/contextVariables';
import CollegeLoacations from '../FFCAOamdc/CollegeLocations';

export default function AffiliationDocuments() {
  const acYear = sessionStorage.getItem('ac_year');
  const name = sessionStorage.getItem('instName');

  const afflDocFormik = useFormik({
    initialValues: {},
  })
  const [Documents, setDocuments] = useState({
    eopData: []
  });

  useEffect(() => {
    GetAfflDocuments();
  }, []);

  function GetAfflDocuments() {
    let url = config.url.API_URL + `getDocumentsData`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data) {
        setDocuments(res?.data);
      } else {
        setDocuments({ eopData: [] });
      }
    }).catch(() => {
      setDocuments({ eopData: [] });
    });
  }
  return (
    <>
      <CommonFormHeading heading={`${name} List of Documents ${acYear}`} />
      <bie.Container fluid className="px-1" >
        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
          <FormikProvider value={afflDocFormik}>
            <bie.Row className="px-2 pt-3 mb-3">
              <Form onChange={afflDocFormik.handleChange} onSubmit={afflDocFormik.handleSubmit}>

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0"> Approvals section</h1></div>
                <div className='d-flex align-items-center'>
                  <div xs={12} sm={12} md={12} lg={8} xl={6} xxl={6} className='mb-2'>
                    <span ><b>Latest EOP/EOA issued by Competent Authority (AICTE/APSCHE/BCI/NCTE)</b></span>
                  </div> &emsp;
                  <div xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2 text-start'>{Documents?.eopData[0]?.lat_eop_order_pdf !== "null" && Documents?.eopData[0]?.lat_eop_order_pdf !== "nullnull" && Documents?.eopData[0]?.lat_eop_order_pdf !== "-" ? (
                    <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.lat_eop_order_pdf) }}><FaEye size={20} /></button>
                  ) : (
                    <b>-</b>
                  )}
                  </div>
                </div>
                {(Documents?.pgCourses?.length ?? 0) > 0 && (<>
                  <div className="inner-herbpage-service-title-sub">
                    <h1 className="mb-0">  Compliance of the Deficiencies Reported in Affiliation Order {AC_YEAR_OLD}</h1></div>

                  <div className="table-responsive">
                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                      aria-hidden="true">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>List of Deficiencies</th>
                          <th>Any evidentiary document to support /justify Claim of Compliance</th>
                        </tr>
                      </thead>
                      {Documents?.pgCourses?.map((course, index) => (
                        <>
                          <tbody>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className='text-left'> {course?.description} </td>
                              <td>{course?.coll_deficiency_pdf !== "nullnull" && course?.coll_deficiency_pdf !== "null" && course?.coll_deficiency_pdf !== "-" ? (
                                <button type="button" className="btn btn-primary" onClick={() => { viewImage(course?.coll_deficiency_pdf) }}><FaEye size={20} /></button>
                              ) : (
                                <span>-</span>
                              )}
                              </td>
                            </tr>
                          </tbody>
                        </>
                      ))}

                    </table>
                  </div>
                </>)}

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">  Society Details
                  </h1></div>

                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                    aria-hidden="true">
                    <thead>
                      <tr>
                        <th>Society Name</th>
                        <th>Society Registration No.	</th>
                        <th>District</th>
                        <th> Type of the Organisation	</th>
                        <th>Society Registration Certificate</th>
                      </tr>  </thead>
                    <tbody>
                      <tr><td>{Documents?.eopData[0]?.society_name}</td>
                        <td>{Documents?.eopData[0]?.society_reg_no}</td>
                        <td>{Documents?.eopData[0]?.society_dist ?? '-'}</td>
                        <td>{Documents?.eopData[0]?.type_of_organization}</td>
                        <td>{Documents?.eopData[0]?.certi_roc !== "nullnull" && Documents?.eopData[0]?.certi_roc !== "null" && Documents?.eopData[0]?.certi_roc !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.certi_roc) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">  College Approval Details</h1></div>

                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                    aria-hidden="true">
                    <tbody>
                      <tr>
                        <td className='text-left'>Institute Address Proof	</td>
                        <td >{Documents?.eopData[0]?.inst_addr_proof_pdf !== "nullnull" && Documents?.eopData[0]?.inst_addr_proof_pdf !== "null" && Documents?.eopData[0]?.inst_addr_proof_pdf !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.inst_addr_proof_pdf) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'>Initial Permission Order of Competant Authority	</td>
                        <td>{Documents?.eopData[0]?.competant_authority_pdf !== "nullnull" && Documents?.eopData[0]?.competant_authority_pdf !== "null" && Documents?.eopData[0]?.competant_authority_pdf !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.competant_authority_pdf) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>

                      {/* <tr>
                        <td>Affiliation Order of Academic year {AC_YEAR_OLD}		</td>
                        <td>{Documents?.eopData[0]?.prev_yr_affl_order_new !== "nullnull" && Documents?.eopData[0]?.prev_yr_affl_order_new !== "null" && Documents?.eopData[0]?.prev_yr_affl_order_new !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.prev_yr_affl_order_new) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr> */}
                      <tr>
                        <td className='text-left'>Autonomous UGC Issued Order		</td>
                        <td>{Documents?.eopData[0]?.ugc_yr_affl_order !== "nullnull" && Documents?.eopData[0]?.ugc_yr_affl_order !== "null" && Documents?.eopData[0]?.ugc_yr_affl_order !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.ugc_yr_affl_order) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'>Autonomous University Issued Order		</td>
                        <td>{Documents?.eopData[0]?.university_yr_affl_order !== "nullnull" && Documents?.eopData[0]?.university_yr_affl_order !== "null" && Documents?.eopData[0]?.university_yr_affl_order !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.university_yr_affl_order) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>
                      <tr>
                        <td className='text-left'>UGC Certificate		</td>
                        <td>{Documents?.eopData[0]?.ugc_certi !== "nullnull" && Documents?.eopData[0]?.ugc_certi !== "null" && Documents?.eopData[0]?.ugc_certi !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.ugc_certi) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'> NAAC Accreditation Certificate	</td>
                        <td >{Documents?.eopData[0]?.naac_accred_certi !== "nullnull" && Documents?.eopData[0]?.naac_accred_certi !== "null" && Documents?.eopData[0]?.naac_accred_certi !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.naac_accred_certi) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>
                      <tr>
                        <td className='text-left'>NBA Accreditation Certificate	</td>
                        <td>{Documents?.eopData[0]?.nba_accred_certi !== "nullnull" && Documents?.eopData[0]?.nba_accred_certi !== "null" && Documents?.eopData[0]?.nba_accred_certi !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.nba_accred_certi) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* <div className="inner-herbpage-service-title-sub-sidemenu pt-4">
                  <h1 className="m-0 p-0 pb-2"> Society Land Allotment Details</h1></div> */}
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0"> Land Details</h1></div>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                    aria-hidden="true">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Document No./Year	</th>
                        <th>Date of Registration<br />(dd/mm/yyyy)</th>
                        <th>Survey No.	</th>
                        <th>Extent of Land (in Acres)    </th>
                        <th>District</th>
                        <th>RO Division</th>
                        <th>Registrar Office</th>
                        <th> Upload Land<br /> Registration Document</th>
                        <th>Upload Land EC	</th>
                        <th>Is Land Mortagaged</th>
                        <th>Mortagage <br /> registrared Document No</th>
                      </tr>
                    </thead>
                    {Documents?.ugCourses?.map((course, index) => (<>
                      <tbody>
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td> {course?.reg_no} </td>
                          <td>  {course?.reg_date}</td>
                          <td>  {course?.survey_no}</td>
                          <td> {course?.area_acres} </td>
                          <td>{course?.dist_name}  </td>
                          <td>  {course?.sro_div_name}</td>
                          <td> {course?.sro_location} </td>
                          <td className='text-center'>{course?.upload_reg_doc !== "nullnull" && course?.upload_reg_doc !== "null" && course?.upload_reg_doc !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(course?.upload_reg_doc) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}
                          </td>

                          <td>{course?.land_ec_doc !== "nullnull" && course?.land_ec_do !== "null" && course?.land_ec_do !== '-' ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(course?.land_ec_doc) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}
                          </td>
                          <td> {course?.is_land_mortgaged} </td>
                          <td> {course?.mortgage_registered_doc_no} </td>
                        </tr>
                      </tbody>
                    </>))}
                  </table>
                </div>


                {Documents?.eopData[0]?.build_own_lease === "Own" && (<>
                  <div className="table-responsive" >
                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                      aria-hidden="true">
                      <tbody>
                        <tr>

                          <td className='text-left'>Land Conversion		</td>
                          <td>{Documents?.eopData[0]?.land_conversion_file !== "nullnull" && Documents?.eopData[0]?.land_conversion_file !== "null" && Documents?.eopData[0]?.land_conversion_file !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.land_conversion_file) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}</td>
                          {/* </tr>
                        <tr> */}
                          <td className='text-left'>Khasra Plan	</td>
                          <td>{Documents?.eopData[0]?.khasra_plan_file !== "nullnull" && Documents?.eopData[0]?.khasra_plan_file !== "null" && Documents?.eopData[0]?.khasra_plan_file !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.khasra_plan_file) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}</td>
                        </tr>

                        <tr>
                          <td className='text-left'>Occupancy Plan		</td>
                          <td>{Documents?.eopData[0]?.occupancy_plan_file !== "nullnull" && Documents?.eopData[0]?.occupancy_plan_file !== "null" && Documents?.eopData[0]?.occupancy_plan_file !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.occupancy_plan_file) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}</td>
                          {/* </tr>
                        <tr> */}
                          <td className='text-left'>  Society Resolution ( Allotment of Land to college)			</td>
                          <td>{Documents?.eopData[0]?.land_usage_certificate !== "nullnull" && Documents?.eopData[0]?.land_usage_certificate !== "null" && Documents?.eopData[0]?.land_usage_certificate !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.land_usage_certificate) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}</td>
                        </tr>
                        <tr>
                          <td className='text-left'>Land Usage	</td>
                          <td>{Documents?.eopData[0]?.land_usage_certificate !== "nullnull" && Documents?.eopData[0]?.land_usage_certificate !== "null" && Documents?.eopData[0]?.land_usage_certificate !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.land_usage_certificate) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}
                          </td>
                          <td>-</td>
                          <td>-</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </>)}

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">  College Building Approval Details
                  </h1></div>

                <div className="table-responsive" >
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true">
                    <thead>
                      <tr>
                        <th>S no</th>
                        <th>Proceedings of Approved<br /> Building Plans till date	</th>
                        <th>Approved Building Plans till date</th>

                      </tr>

                    </thead>

                    <tbody>
                      {Documents?.labdata?.map((course, index) => (<>
                        <tr key={index}>
                          <td className='cen'>{index + 1}</td>
                          <td className='cen'>{course?.proceeding_approved_building_plans !== "nullnull" && course?.proceeding_approved_building_plans !== "null" && course?.proceeding_approved_building_plans !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(course?.proceeding_approved_building_plans) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}
                          </td>
                          <td className='cen'>{course?.approved_building_plans !== "nullnull" && course?.approved_building_plans !== "null" && course?.approved_building_plans !== "-" ? (
                            <button type="button" className="btn btn-primary" onClick={() => { viewImage(course?.approved_building_plans) }}><FaEye size={20} /></button>
                          ) : (
                            <span>-</span>
                          )}
                          </td>
                        </tr>
                      </>))}

                    </tbody>
                  </table>
                </div>

                <div className="table-responsive" >
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true">
                    <tbody>
                      <tr>
                        <td className='text-left'>College Building Picture attested by Principal		</td>
                        <td >{Documents?.eopData[0]?.college_building_photo !== "nulllnull" && Documents?.eopData[0]?.college_building_photo !== "null" && Documents?.eopData[0]?.college_building_photo !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.college_building_photo) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'>Building Plan by Architect		</td>
                        <td>{Documents?.eopData[0]?.building_plan_licensed_architect !== "nullnull" && Documents?.eopData[0]?.building_plan_licensed_architect !== "null" && Documents?.eopData[0]?.building_plan_licensed_architect !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.building_plan_licensed_architect) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>

                      <tr>
                        <td className='text-left'>Fire department NOC		</td>
                        <td>{Documents?.eopData[0]?.fire_certificate_doc !== "nullnull" && Documents?.eopData[0]?.fire_certificate_doc !== "null" && Documents?.eopData[0]?.fire_certificate_doc !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.fire_certificate_doc) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'>Structural Stability Certiificate	</td>
                        <td>{Documents?.eopData[0]?.structural_certificate !== "nullnull" && Documents?.eopData[0]?.structural_certificate !== "null" && Documents?.eopData[0]?.structural_certificate !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.structural_certificate) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>

                      <tr>
                        <td className='text-left'>Sanitary Certificate	</td>
                        <td >{Documents?.eopData[0]?.sanitary_provision_file !== "nullnull" && Documents?.eopData[0]?.sanitary_provision_file !== "null" && Documents?.eopData[0]?.sanitary_provision_file !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.sanitary_provision_file) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        <td>-</td>
                        <td>-</td>

                      </tr>

                    </tbody>
                  </table >
                </div>

                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">  Financial Details of the Institution
                  </h1></div>
                <div className="table-responsive" >
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                    aria-hidden="true">

                    <tbody>

                      <tr><td className='text-left'>FDR Upload 1	</td>
                        <td>{Documents?.eopData[0]?.fd_bond_certi !== "nullnull" && Documents?.eopData[0]?.fd_bond_certi !== "null" && Documents?.eopData[0]?.fd_bond_certi !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.fd_bond_certi) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'>FDR Upload 2</td>
                        <td >{Documents?.eopData[0]?.fd_bond_certi_2 !== "nullnull" && Documents?.eopData[0]?.fd_bond_certi_2 !== "null" && Documents?.eopData[0]?.fd_bond_certi_2 !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.fd_bond_certi_2) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>

                      <tr><td className='text-left'>FDR Upload 3	</td>
                        <td>{Documents?.eopData[0]?.fd_bond_certi_3 !== "nullnull" && Documents?.eopData[0]?.fd_bond_certi_3 !== "null" && Documents?.eopData[0]?.fd_bond_certi_3 !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.fd_bond_certi_3) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        {/* </tr>
                      <tr> */}
                        <td className='text-left'>FDR Upload 4</td>
                        <td >{Documents?.eopData[0]?.fd_bond_certi_4 !== "nullnull" && Documents?.eopData[0]?.fd_bond_certi_4 !== "null" && Documents?.eopData[0]?.fd_bond_certi_4 !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.fd_bond_certi_4) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>

                      <tr>
                        <td className='text-left'>Latest Financial Audit Report given by CA	</td>
                        <td>{Documents?.eopData[0]?.audit_certi !== "nullnull" && Documents?.eopData[0]?.audit_certi !== "null" && Documents?.eopData[0]?.audit_certi !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.audit_certi) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                        <td>-</td>
                        <td>-</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">  Facilities</h1></div>
                <div className="table-responsive" >
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true">

                    <tbody>

                      <tr><td className='text-left'>Playground Tie-up Document		</td>
                        <td> {Documents?.eopData[0]?.tieup_document !== "nullnull" && Documents?.eopData[0]?.tieup_document !== "null" && Documents?.eopData[0]?.tieup_document !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.tieup_document) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>

                        <td className='text-left'> Parking Area Document	</td>
                        <td> {Documents?.eopData[0]?.parking_area_document !== "nullnull" && Documents?.eopData[0]?.parking_area_document !== "null" && Documents?.eopData[0]?.parking_area_document !== "-" ? (
                          <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.parking_area_document) }}><FaEye size={20} /></button>
                        ) : (
                          <span>-</span>
                        )}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div className="inner-herbpage-service-title-sub">
                  <h1 className="mb-0">  Affidavit Details</h1></div>
                <div className="table-responsive" >
                  <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation" aria-hidden="true">
                    <tbody>

                      <tr><td className='text-left'>Affidavit Document	</td><td>{Documents?.eopData[0]?.affidavit_pdf !== "nullnull" && Documents?.eopData[0]?.affidavit_pdf !== "null" && Documents?.eopData[0]?.affidavit_pdf !== "-" ? (
                        <button type="button" className="btn btn-primary" onClick={() => { viewImage(Documents?.eopData[0]?.affidavit_pdf) }}><FaEye size={20} /></button>
                      ) : (
                        <span>-</span>
                      )}</td></tr>

                    </tbody>
                  </table>
                </div>

              </Form>
            </bie.Row>
          </FormikProvider>
        </bie.Container>
      </bie.Container>

    </>
  )
}
